import { AudioManager } from "../multigame/AudioManager";


export class AudioService extends AudioManager
{
    
}